import React, { useState, useEffect } from "react";
import CarForm from "../components/CarForm";
import ContattiForm from "../components/Form/Contatti";
import { replace } from "react-router-dom";

const Form = ({ contenuti }) => {
  // 1) Normalizzo sempre in array
  const contenutiArray = (Array.isArray(contenuti)
    ? contenuti
    : Object.values(contenuti)).sort((a, b) => Number(a.ordine) - Number(b.ordine));




  // 2) Rilevo se sono in mobile (se ti serve nel layout)
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 992);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <section className="my-5">
      {contenutiArray.map((item, idx) => {
        const {
          titolo_it,
          descrizione_it,
          call_to_action_it,
          tema,           // qui dentro hai .form, .api, .task…
        } = item;

        

        const titoloLines = titolo_it && titolo_it.includes("|")
        ? titolo_it.split("|").map(str => str.trim())
        : [titolo_it];

        titoloLines[0] = titoloLines[0] === 'Form' ? '' : titoloLines[0];

        return (
            <div className="container" style={{ marginBottom: 100 }}>
              <div className="row f-flex flex-column flex-md-row">
                {tema?.form && Array.isArray(tema.form) && tema.form.length > 0 ? (
                  // 1) Se c’è un form, mostro solo il CarForm
                  <CarForm
                    formConfig={tema.form}
                    apiEndpoint={tema.api}
                    task={tema.task}
                    isMobile={isMobile}
                    submit={call_to_action_it ?? ''}
                  />
                ) : (
                  // 2) Altrimenti mostro titolo e descrizione
                  <>
                    <div className="col-12 col-md-6 title-section">
                      {titoloLines.map((line, i) => {
                        const className =
                          i === 0
                            ? "title-section"
                            : "green-medium title-section";

                        return (
                          <h2 key={i} className={className}>
                            {line}
                          </h2>
                        );
                      })}
                    </div>

                    <div className="col-12 col-md-6">
                      {descrizione_it && (
                        <div
                          className="medium"
                          dangerouslySetInnerHTML={{ __html: descrizione_it }}
                        />
                      )}
                    </div>
                  </>
                )}
              </div>

              </div>
        );
      })}
    </section>
  );
};

export default Form;
